import { render, staticRenderFns } from "./TodoActionsMenu.vue?vue&type=template&id=1ee9efe3&scoped=true"
import script from "./TodoActionsMenu.vue?vue&type=script&lang=ts"
export * from "./TodoActionsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee9efe3",
  null
  
)

export default component.exports